import { render, staticRenderFns } from "./OrdersTimeLoadChart.vue?vue&type=template&id=16327f96&scoped=true&"
import script from "./OrdersTimeLoadChart.vue?vue&type=script&lang=js&"
export * from "./OrdersTimeLoadChart.vue?vue&type=script&lang=js&"
import style0 from "./OrdersTimeLoadChart.vue?vue&type=style&index=0&id=16327f96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16327f96",
  null
  
)

export default component.exports